<template>
  <div
    v-show="isShow"
    class="flex flex-wrap align-center"
    data-qa="compare-actions-snackbar">
    <ChooseWinnerBtn
      :mode="winnerMode"
      :options="winnerOptions"
      @showActions="val => showChooseWinner = !!val.toolbar"/>
    <AskQuestion
      v-if="showAskQuestion"
      :bids="positionsElements"
      :tender="options.tender"/>
  </div>
</template>

<script>
import AskQuestion from 'components/tenders/dialogs/AskQuestion.vue'
import ChooseWinnerBtn from 'components/tenders/tender page/ChooseWinnerBtn.vue'

import { tenderMixin } from 'mixins'
import { flattenLotGroupPositions } from 'helpers/lotGroupPositions'

export default {
  name: 'compareActionsToolbar',
  mixins: [tenderMixin],
  data() {
    return {
      // ChooseWinnerBtn сам вирішує, чи показувати кнопку, і повідомляє через showActions
      showChooseWinner: false
    }
  },
  props: {
    options: Object,
    reject_condition: Boolean
  },
  computed: {
    isShow() {
      return this.showChooseWinner || this.showAskQuestion
    },
    showAskQuestion() {
      return (this.can_edit || this.options.tender?.tenderAccess?.includes('ALLOW_SEND_SUPPLIER_QUESTION'))
        && this.$can('set', 'privateMessageToBidder')
        && !this.options.tender.hasRoute
        && (!this.options.isLotGroups || !this.positionsElements.some(bid => bid.foreignBidderBid))
    },
    can_edit() {
      return this.$_checkCanEdit(this.options.tender, this.$_agreements)
    },
    elements() {
      let elems = this.options.elements || []
      this.$emit('update:reject_condition', !!elems && elems.length > 1 )
      return elems
    },
    first() {
      return this.elements[0] || {}
    },
    /**
     * У режимі лот-позицій обрані елементи — агреговані рядки (постачальник × лот),
     * дії виконуються над усіма їхніми позиціями (як в OffersGroupActionsToolbar)
     */
    positionsElements() {
      return this.options.isLotGroups ? flattenLotGroupPositions(this.elements) : this.elements
    },
    winnerOptions() {
      return this.options.isLotGroups ? { ...this.options, elements: this.positionsElements } : this.options
    },
    winnerMode() {
      if (!this.options.isLotGroups) {
        return 'default'
      }
      return this.first.selectedBid ? 'remove' : 'select'
    },
  },
  components: {
    AskQuestion,
    ChooseWinnerBtn
  }
}
</script>
